import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
  component: () => <HomeComponent />,
});

const HomeComponent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: "/c" });
  }, []);

  return <></>;
};
